export default {
  mounted() {
    const decodeBase64 = (data) => {
      const binary = atob(data);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes;
    };

    const performDownload = ({ filename, content, type, encoding }) => {
      if (!filename || !content) return;

      const payload =
        encoding === "base64" ? decodeBase64(content) : content;

      const blob = new Blob([payload], { type: type || "text/plain" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    // Server-driven event for downloads
    this.handleEvent("download", performDownload);

    // Server-driven event for opening URLs in new tab
    this.handleEvent("open_url", ({ url }) => {
      window.open(url, '_blank');
    });

    // Client-dispatched DOM event fallback
    const handler = (e) => {
      const detail = e.detail || {};
      if (detail.filename && detail.content) {
        performDownload(detail);
      }
    };
    window.addEventListener("phx:download", handler);
    this.el.addEventListener && this.el.addEventListener("phx:download", handler);
  }
};
